export default "__VITE_ASSET__BpINHwu1__"